import React, { useEffect, useState } from 'react';
import { pageService } from 'services/page.service';

const usePrivacyPolicy = () => {
    const [policyData, setPolicyData] = useState({});

    const handleApi = async () => {
        try {
            const response = await pageService.privacyPage()
            setPolicyData(response.data.data)
        } catch (err) {
            console.log(err)
        }
    }

    useEffect(() => {
        handleApi();
    }, []);

    return { policyData };
}

export default usePrivacyPolicy;